import { TabItem, ResolvedBlock } from './tab-block';
import { renderRichText } from '../../../core/utils/render-rich-text.util';
import { resolveStrapiMediaUrl } from '../../../core/utils/strapi-media.util';
import { COMPONENT_REGISTRY } from '../../../core/dynamic-zone/component-registry';

export function adaptTabBlock(
  entry: Record<string, unknown>,
  baseUrl: string,
): Record<string, unknown> {
  const rawTabs = entry['tabs'];
  const tabs: TabItem[] = Array.isArray(rawTabs)
    ? rawTabs.map((t: Record<string, unknown>) => {
        const img = t['image'] as Record<string, unknown> | null | undefined;
        const width = img?.['width'];
        const height = img?.['height'];
        const hasDimensions = typeof width === 'number' && Number.isFinite(width) && width > 0
          && typeof height === 'number' && Number.isFinite(height) && height > 0;
        const rawBlocks = t['blocks'] as Record<string, unknown>[] | null | undefined;

        let resolvedBlocks: ResolvedBlock[] | undefined;
        if (Array.isArray(rawBlocks) && rawBlocks.length > 0) {
          resolvedBlocks = [];
          for (const block of rawBlocks) {
            const componentId = block['__component'] as string;
            const registryEntry = COMPONENT_REGISTRY[componentId];
            if (registryEntry) {
              try {
                const inputs = registryEntry.adapter(block, baseUrl);
                resolvedBlocks.push({ component: registryEntry.component, inputs });
              } catch (err) {
                console.error(`[TAB_BLOCK] Adapter error for ${componentId}`, err);
              }
            }
          }
        }

        return {
          label: (t['label'] as string) ?? '',
          content: renderRichText((t['content'] as string) ?? ''),
          image: img ? resolveStrapiMediaUrl(baseUrl, (img['url'] as string) ?? null) ?? undefined : undefined,
          imageAlt: img ? ((img['alternativeText'] as string) ?? '') : undefined,
          imageWidth: hasDimensions ? width : undefined,
          imageHeight: hasDimensions ? height : undefined,
          resolvedBlocks: resolvedBlocks?.length ? resolvedBlocks : undefined,
        };
      })
    : [];

  return { tabs };
}
